import envVar from '../config/envVars';
import httpPost from './httpClient/httpPost';
import httpGet from './httpClient/httpGet';

interface GenerateConsolidatedMarksPayload {
  academicYear: string;
  grade: string;
  division: string;
  userId: string;
  termIds: string[];
}

const generateConsolidatedMarksReport = async (
  school: string,
  payload: GenerateConsolidatedMarksPayload
) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/reports/consolidated-marks`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

interface GetConsolidatedMarksParams {
  school: string;
  academicYear: string;
  grade: string;
  division: string;
  isDetailedReport?: boolean;
  examIds?: string[]; 
}

const getConsolidatedMarksReport = async (
  params: GetConsolidatedMarksParams
) => {
  const { school, academicYear, grade, division, isDetailedReport, examIds } = params;
  const query: string[] = [];
  if (isDetailedReport !== undefined) {
    query.push(`isDetailedReport=${isDetailedReport}`);
  }
  if (examIds && examIds.length) {
    query.push(`examIds=${examIds.join(',')}`);
  }
  const qs = query.length ? `?${query.join('&')}` : '';
  return httpGet(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/ay/${academicYear}/grade/${grade}/division/${division}/reports/consolidated-marks${qs}`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const marksAnalyticsApis = {
  generateConsolidatedMarksReport,
  getConsolidatedMarksReport
};

export default marksAnalyticsApis;
